import {createRouter, createWebHistory} from 'vue-router'
import {panelRoutes} from '@/router/panelRoutes.js';
import {HomeRoute} from "@/router/homeRoute.js";
import {errors} from "@/router/errors";
import {agents} from "@/router/agents";


const routes = [

    //import home
    ...HomeRoute,
    //import panel
    ...panelRoutes,
    ///agents
    ...agents,
    ///errors
    ...errors

]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
